import ControlCenterModule from './ControlCenterModule.vue';
import ConnectToRobot from './views/ConnectToRobot.vue';
import ControlCenter from './views/ControlCenter.vue';
import GitLogin from './views/GitLogin.vue';
import GitMenu from './views/GitMenu.vue';
export const controlCenterRoutes = [
  {
    path: '/controlCenter/:workspaceId',
    name: 'ControlCenter',
    component: ControlCenterModule,
    children: [
      {
        path: '',
        name: 'ControlCenter.HomePage',
        component: ControlCenter
      },
      {
        path: 'connect',
        name: 'ControlCenter.Connect',
        component: ConnectToRobot
      },
      {
        path: 'git',
        name: 'ControlCenter.Git',
        component: GitLogin
      },
      {
        path: 'gitMenu',
        name: 'ControlCenter.GitMenu',
        component: GitMenu
      }
    ]
  }
];
